import { render } from "./InputCourse.vue?vue&type=template&id=2cf4d6f3"
import script from "./InputCourse.vue?vue&type=script&lang=ts"
export * from "./InputCourse.vue?vue&type=script&lang=ts"
script.render = render

export default script